var _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJournal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.6908,
    cy: 17.6908,
    r: 17.6908,
    fill: "url(#paint0_linear_10129_47188)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.487 25.0597H11.9038C11.0317 25.0597 10.3242 24.3522 10.3242 23.4802V11.8969C10.3242 11.0249 11.0317 10.3174 11.9038 10.3174H23.487C24.3591 10.3174 25.0666 11.0249 25.0666 11.8969V23.4802C25.0666 24.3522 24.3591 25.0597 23.487 25.0597ZM18.1594 15.1185L13.6939 19.584L13.4866 21.463C13.4603 21.7131 13.6709 21.927 13.9242 21.9006L15.8032 21.6933L20.2687 17.2278C20.3444 17.1521 20.3444 17.0271 20.2687 16.9481L18.4424 15.1218C18.3601 15.0428 18.2351 15.0428 18.1594 15.1185ZM21.6771 14.6973L20.6866 13.7068C20.3773 13.3975 19.8771 13.3975 19.5711 13.7068L18.8109 14.4669C18.7353 14.5426 18.7353 14.6677 18.8109 14.7466L20.6373 16.573C20.713 16.6487 20.838 16.6487 20.917 16.573L21.6771 15.8128C21.9832 15.5068 21.9832 15.0066 21.6771 14.6973Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.487 25.0597H11.9038C11.0317 25.0597 10.3242 24.3522 10.3242 23.4802V11.8969C10.3242 11.0249 11.0317 10.3174 11.9038 10.3174H23.487C24.3591 10.3174 25.0666 11.0249 25.0666 11.8969V23.4802C25.0666 24.3522 24.3591 25.0597 23.487 25.0597ZM18.1594 15.1185L13.6939 19.584L13.4866 21.463C13.4603 21.7131 13.6709 21.927 13.9242 21.9006L15.8032 21.6933L20.2687 17.2278C20.3444 17.1521 20.3444 17.0271 20.2687 16.9481L18.4424 15.1218C18.3601 15.0428 18.2351 15.0428 18.1594 15.1185ZM21.6771 14.6973L20.6866 13.7068C20.3773 13.3975 19.8771 13.3975 19.5711 13.7068L18.8109 14.4669C18.7353 14.5426 18.7353 14.6677 18.8109 14.7466L20.6373 16.573C20.713 16.6487 20.838 16.6487 20.917 16.573L21.6771 15.8128C21.9832 15.5068 21.9832 15.0066 21.6771 14.6973Z",
    fill: "url(#paint1_linear_10129_47188)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10129_47188",
    x1: 3.93129,
    y1: 30.1399,
    x2: 35.3816,
    y2: 12.0123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF939C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC7CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10129_47188",
    x1: 10.3242,
    y1: 23.6264,
    x2: 25.0666,
    y2: 13.5934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1525F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF818B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournal);
export default __webpack_public_path__ + "static/media/Journal.a7d466b99acc07ad969d186755a6df8b.svg";
export { ForwardRef as ReactComponent };